export default __webpack_public_path__ + "static/media/prize-4.2a6513f5.webp";